/**
 * Estado de la conexión realtime. Mapea al indicador verde/amarillo/rojo del
 * shell (resiliencia de red del operador).
 *
 *  - connected     → verde
 *  - connecting    → amarillo (primer intento)
 *  - reconnecting  → amarillo (backoff tras caída; el store se sanea con snapshot REST)
 *  - disconnected  → rojo (sin conexión, agotó reintentos o offline)
 *  - idle          → gris (aún no se intentó conectar)
 */
export type ConnectionStatus =
  | 'idle'
  | 'connecting'
  | 'connected'
  | 'reconnecting'
  | 'disconnected';

export type ConnectionHealth = 'green' | 'yellow' | 'red' | 'grey';

export function healthOf(status: ConnectionStatus): ConnectionHealth {
  switch (status) {
    case 'connected':
      return 'green';
    case 'connecting':
    case 'reconnecting':
      return 'yellow';
    case 'disconnected':
      return 'red';
    case 'idle':
    default:
      return 'grey';
  }
}
